import type { AuthoredNarrativeBundle } from './authoredNarrativeRender';

export type StructuredMethodology = {
  primarySources: string[];
  calculation: string[];
  limitations: string[];
  technicalDetails: string[];
};

export type MethodologyContentLegacy = {
  title: string;
  description: string;
  dataSources: string[];
  methodology: string[];
};

/**
 * When structured methodology exists, omit legacy dataSources/methodology lists
 * so MethodologyContent does not duplicate source information.
 */
export function resolveMethodologyContentProps(
  structured: StructuredMethodology | undefined | null,
  legacy: MethodologyContentLegacy
): MethodologyContentLegacy & {
  primarySourcesDetailed?: string[];
  climatePlansCalculation?: string[];
  limitations?: string[];
  technicalDetails?: string[];
} {
  const hasStructured =
    structured &&
    (structured.primarySources.length > 0 ||
      structured.calculation.length > 0 ||
      structured.limitations.length > 0 ||
      structured.technicalDetails.length > 0);

  if (!hasStructured) {
    return legacy;
  }

  return {
    title: legacy.title,
    description: legacy.description,
    dataSources: [],
    methodology: [],
    primarySourcesDetailed: structured.primarySources,
    climatePlansCalculation: structured.calculation,
    limitations: structured.limitations,
    technicalDetails: structured.technicalDetails,
  };
}

export function structuredFromAuthoredBundle(
  bundle: AuthoredNarrativeBundle | null | undefined
): StructuredMethodology | undefined {
  return bundle?.methodology;
}
